import createIcon from '../../createIcon';

/**
 * @component @name Voicemail
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTguNSA2LjVDMTUuNDYgNi41IDEzIDguOTYgMTMgMTJDMTMgMTMuMzMgMTMuNDcgMTQuNTUgMTQuMjYgMTUuNUg5Ljc0QzEwLjUzIDE0LjU1IDExIDEzLjMzIDExIDEyQzExIDguOTYgOC41NCA2LjUgNS41IDYuNUMyLjQ2IDYuNSAwIDguOTYgMCAxMkMwIDE1LjA0IDIuNDYgMTcuNSA1LjUgMTcuNUgxOC41QzIxLjU0IDE3LjUgMjQgMTUuMDQgMjQgMTJDMjQgOC45NiAyMS41NCA2LjUgMTguNSA2LjVaTTUuNSAxNS41QzMuNTcgMTUuNSAyIDEzLjkzIDIgMTJDMiAxMC4wNyAzLjU3IDguNSA1LjUgOC41QzcuNDMgOC41IDkgMTAuMDcgOSAxMkM5IDEzLjkzIDcuNDMgMTUuNSA1LjUgMTUuNVpNMTguNSAxNS41QzE2LjU3IDE1LjUgMTUgMTMuOTMgMTUgMTJDMTUgMTAuMDcgMTYuNTcgOC41IDE4LjUgOC41QzIwLjQzIDguNSAyMiAxMC4wNyAyMiAxMkMyMiAxMy45MyAyMC40MyAxNS41IDE4LjUgMTUuNVoiIGZpbGw9ImJsYWNrIi8+Cjwvc3ZnPgo=)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Voicemail = createIcon('Voicemail', [
  [
    'path',
    {
      d: 'M18.5 6.5C15.46 6.5 13 8.96 13 12C13 13.33 13.47 14.55 14.26 15.5H9.74C10.53 14.55 11 13.33 11 12C11 8.96 8.54 6.5 5.5 6.5C2.46 6.5 0 8.96 0 12C0 15.04 2.46 17.5 5.5 17.5H18.5C21.54 17.5 24 15.04 24 12C24 8.96 21.54 6.5 18.5 6.5ZM5.5 15.5C3.57 15.5 2 13.93 2 12C2 10.07 3.57 8.5 5.5 8.5C7.43 8.5 9 10.07 9 12C9 13.93 7.43 15.5 5.5 15.5ZM18.5 15.5C16.57 15.5 15 13.93 15 12C15 10.07 16.57 8.5 18.5 8.5C20.43 8.5 22 10.07 22 12C22 13.93 20.43 15.5 18.5 15.5Z',
      key: 'jkxzm3',
    },
  ],
]);

export default Voicemail;
